import { useQuery } from '@tanstack/react-query';
import { fetchCase } from '../api/cases';

/**
 * Fetches a single case by case number.
 * @param {string} caseNumber
 */
export const useCase = (caseNumber) => {
  return useQuery({
    queryKey: ['case', caseNumber],
    queryFn: () => fetchCase(caseNumber),
    enabled: Boolean(caseNumber),
    staleTime: 30_000,
  });
};
